module.exports = __webpack_public_path__ + "static/media/_MIC2709.thumbnail.220bf86f.png";